const womenBeltsIds = ['91'];
const womenAccessoriesWithSizes = ['91', '89'];
const womenBrasIds = ['17'];
const womenClothingIds = ['2'];
const womenGlovesIds = ['83'];
const womenHatsIds = ['89'];
const womenJeansIds = ['10'];
const womenShoesIds = ['108', '110', '111', '112', '114', '121', '120', '122'];
const womenRingsIds = ['74'];
const womenJewelryIds = ['69'];
const womenEyewearIds = ['84'];

// const menAccessoriesIds = ['178'];
const menAccessoriesWithSizes = ['187', '185'];
const menBeltsIds = ['187'];
const menClothingIds = ['125'];
const menGlovesIds = ['179'];
const menHatsIds = ['185'];
const menJeansIds = ['126'];
const menShirtsIds = ['148'];
const menShoesIds = ['202', '204', '205', '206', '207', '210'];
const menRingsIds = ['171'];
const menJewelryIds = ['167'];
const menEyewearIds = ['180'];

/* const womenCoatsAndJackets = ['28', '29', '30', '31', '32', '33', '34', '35'];
const menCoatsAndJackets = ['136', '137', '138', '139', '140', '141', '142', '143']; */
const womenJumpsuits = ['68'];
/* const girlsJumpsuits = ['396'];
const boysJumpsuits = ['409'];
const womenShirts = ['41', '42', '43', '44']; */
const menShirts = ['148'];
const womenTopwear = ['57', '58', '59', '60', '61', '62', '63'];
const menTopwear = ['158', '159', '160', '161', '162'];
/* const girlsTopwear = ['390', '391', '392', '393', '394'];
const boysTopwear = ['403', '404', '405', '406', '407'];
const babyGirlsTopwear = ['353', '354', '355', '356', '357'];
const babyBoysTopwear = ['365', '366', '367', '368', '369']; */
const womenDresses = ['13', '14', '15', '16', '288'];
/* const girlsDresses = ['389'];
const babyGirlsDresses = ['352']; */

const genericShoes = ['108' /* , '202' */];
const boots = ['111' /* , '205' */];
const flatShoes = ['112', '345'];
const highHeeledShoes = ['120'];
const lacedShoes = ['114' /* , '207' */];
const sandals = ['121', '212'];
const wedges = ['122'];
const sneakers = ['110' /* '204' */];

// const juniorKidsDepartmentIds = ['385', '399'];
export const juniorKidsClothingIds = [
  '388',
  '389',
  '390',
  '396',
  '395',
  '397',
  '402',
  '409',
  '410',
  '408',
  '403',
  '411',
];
export const juniorKidsShoesIds = ['398', '412'];

export const unisexJuniorShoes = ['425'];

// const babiesDepartmentIds = ['348', '361'];
export const babiesClothingIds = ['351', '352', '358', '353', '364', '370', '365'];
export const babiesShoesIds = ['360', '372'];

export const unisexBabiesShoes = ['384'];

// const unisexAccessoriesIds = ['224'];
export const unisexAccessoriesWithSizes = ['225', '324'];
export const unisexClothingIds = ['293'];
export const unisexHatsIds = ['225'];
export const unisexShoesIds = ['298'];
export const unisexRingsIds = ['248'];

export const allAccessoriesIds = [].concat(
  womenAccessoriesWithSizes,
  menAccessoriesWithSizes,
  unisexAccessoriesWithSizes,
);
export const allEyewear = [...womenEyewearIds, menEyewearIds];
export const allBeltsIds = [].concat(womenBeltsIds, menBeltsIds);
export const allBrasIds = [].concat(womenBrasIds);
export const allClothingIds = [].concat(
  womenClothingIds,
  menClothingIds,
  unisexClothingIds,
  juniorKidsClothingIds,
  babiesClothingIds,
);
export const allGlovesIds = [].concat(womenGlovesIds, menGlovesIds);
export const allHatsIds = [].concat(womenHatsIds, menHatsIds, unisexHatsIds);
export const allJeansIds = [].concat(womenJeansIds, menJeansIds);
export const allShoesIds = [].concat(
  womenShoesIds,
  menShoesIds,
  unisexShoesIds,
  juniorKidsShoesIds,
  babiesShoesIds,
  unisexBabiesShoes,
  unisexJuniorShoes,
);
export const allShirtsIds = [].concat(menShirtsIds);
export const allRingsIds = [].concat(womenRingsIds, menRingsIds, unisexRingsIds);
export const allJelweryIds = [].concat(womenJewelryIds, menJewelryIds);
export const categoriesWithSizes = [].concat(allClothingIds, allShoesIds, allAccessoriesIds, allJelweryIds);
export const categoriesWithSleeveLengths = [
  ...womenJumpsuits,
  ...menShirts,
  ...womenTopwear,
  ...menTopwear,
  ...womenDresses,
];
export const categoriesWithHeelHeights = [...genericShoes, ...boots, ...highHeeledShoes, ...sandals, ...wedges];
export const categoriesWithToeTypes = [
  ...genericShoes,
  ...flatShoes,
  ...highHeeledShoes,
  ...lacedShoes,
  ...sandals,
  ...wedges,
];
export const categoriesWithToeShapes = [
  ...genericShoes,
  ...boots,
  ...flatShoes,
  ...highHeeledShoes,
  ...lacedShoes,
  ...sandals,
  ...wedges,
];

// ids exclusion for whole filter block
export const shoesFiltersExclusion = [...sneakers];
export const highHeeledFiltersExclusion = [...flatShoes];
export const toeTypeShapeFiltersExclusion = [...sandals];

// ids exclusion for singele filter
export const threeQuarterExclusion = [...womenJumpsuits, ...menTopwear, ...menShirts];
export const sleevelessExclusion = [...menShirts];
export const highHeeledShoesExclusion = [...highHeeledShoes];

export const ALL_SLEEVE_LENGTHS = [
  { displayName: 'Sleeveless', excludedIds: [...sleevelessExclusion], value: 'sleeveless' },
  { displayName: 'Short', excludedIds: [], value: 'short' },
  {
    displayName: 'Three-quarter',
    excludedIds: [...threeQuarterExclusion, ...sleevelessExclusion],
    value: 'three_quarter',
  },
  { displayName: 'Long', excludedIds: [], value: 'long' },
];

export const TOE_TYPES_AND_SHAPES = [
  { displayName: 'Closed toe', excludedIds: [], value: 'closed_toe' },
  { displayName: 'Open toe', excludedIds: [], value: 'open_toe' },
  { displayName: 'Pointed toe', excludedIds: [], value: 'pointed' },
  { displayName: 'Round toe', excludedIds: [], value: 'round' },
  { displayName: 'Square toe', excludedIds: [], value: 'square' },
];

export const ALL_HEEL_HEIGHTS = [
  { displayName: 'Flat', excludedIds: [...highHeeledShoesExclusion], value: 'flat' },
  { displayName: 'Low heel', excludedIds: [], value: 'low' },
  { displayName: 'Medium heel', excludedIds: [], value: 'mid' },
  { displayName: 'High heel', excludedIds: [], value: 'high' },
];
